import { render, staticRenderFns } from "./CreateType.vue?vue&type=template&id=52818d28&scoped=true&"
import script from "./CreateType.vue?vue&type=script&lang=ts&"
export * from "./CreateType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52818d28",
  null
  
)

export default component.exports